import { render, staticRenderFns } from "./SDKMessage.vue?vue&type=template&id=51450e82&"
import script from "./SDKMessage.vue?vue&type=script&lang=js&"
export * from "./SDKMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51450e82')) {
      api.createRecord('51450e82', component.options)
    } else {
      api.reload('51450e82', component.options)
    }
    module.hot.accept("./SDKMessage.vue?vue&type=template&id=51450e82&", function () {
      api.rerender('51450e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Message/SDKMessage.vue"
export default component.exports